<div class="dialog-container">
  <div class="container">
    <!-- <button class="button">Save My Apps</button> -->
    <div class="text-content">
        <h2>{{title}}</h2>
    </div>
  </div>
  <ng-container>
    <div>
      <div class="dialog-content text-center" id="dialog-msg" [innerHTML]="message"></div>
      <div class="dialog-footer-btns mt-3">
        <button mat-raised-button id="dismiss-btn" color="secondary" class="button" (click)="onDismiss()">
          {{closeBtnLabel}}
        </button>
        <button mat-raised-button id="confirm-btn" color="primary" class="button" (click)="onConfirm()">
          {{confirmBtnLabel}}
        </button>
      </div>
    </div>
  </ng-container>
</div>